<template>
  <svg viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9424 0.811514L7.98041 3.77353L5.01841 6.73555L1.37852 3.09574"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "s-lk-checkbox-check-icon"
};
</script>
